import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useForm, Controller } from 'react-hook-form';

import { IonButton, IonIcon, IonContent, IonPage, IonRow, IonGrid, IonCol, IonInput, IonItem, IonLabel, IonText, IonLoading } from '@ionic/react';
import { logoGoogle, mail } from 'ionicons/icons';

import Toolbar from '../components/Toolbar';
import { HOME_ROUTER } from '../Routers';

import { User } from 'models/User';

import userService from 'services/UserService';
import authService from '../services/AuthService';

type IFormModel = {
  nome: string,
  email: string,
  senha: string,
}

const Auth: React.FC = () => {
  const history = useHistory();
  const { control, getValues, handleSubmit, errors } = useForm<IFormModel>();

  const [needRegister, setNeedRegister] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  function registerByEmail(dataForm: IFormModel) {
    const { nome, email, senha } = dataForm;

    authService.signUpWithEmail(nome, email, senha)
      .then(async res => {
        await userService.save(User.userFromAuthUser(res.user!))

        goToHome()
      })
      .catch(err => console.log(err))
  }

  function showErrors(errors: any) {
    console.log(errors);
  }

  function loginWithEmailAndPassword(dataForm: IFormModel) {
    const { email, senha } = dataForm;


    authService.signInWithEmail(email, senha)
      .then(() => goToHome())
      .catch(err => console.error(err));
  }

  const loginWithGoogle = () => {
    authService.signInWithGoogle()
      .then(() => goToHome())
      .catch(err => console.error(err));
  }

  const goToHome = useCallback(() => {
    history.push(HOME_ROUTER)
  }, [history])

  const showError = (_fieldName: string, msgError = 'O campo é obrigatório') => {
    return (
      (errors as any)[_fieldName] &&
            <div
              style={{
                color: 'red',
                padding: 5,
                paddingLeft: 12,
                fontSize: 'smaller'
              }}
            >
              {msgError}
            </div>
    )
  }

  const checkIfHasNewLoginByProviders = useCallback(async () => {
    const needRecoveryCredentials = JSON.parse(localStorage.getItem('exitToLoginWithProvider') || 'false')

    if (needRecoveryCredentials) {
      setIsLoading(true)
      authService.recoveryCredentialsInRedirect()
    }
  }, [])

  const resolveRouter = useCallback((isAuthenticated) => {
    if (isAuthenticated) {
      goToHome()
    }
  }, [goToHome])

  useEffect(() => {
    const unsubscribe = authService.observeAuth(isAuthenticated => {
      resolveRouter(isAuthenticated)

      if (isAuthenticated) {
        setIsLoading(false)
      }
    })

    checkIfHasNewLoginByProviders()

    return () => {
      unsubscribe()
    }
  }, [checkIfHasNewLoginByProviders, resolveRouter])

  return (
    <IonPage>
      <IonLoading
        isOpen={isLoading}
        message={'Carregando...'}
      />
      <Toolbar title="Login" infoBtn={true} menuBtn={true} />

      <IonContent className="ion-padding">
        <IonGrid fixed>
          <IonRow className="ion-justify-content-center ion-margin-bottom">
            <IonCol size="auto">
              <img width="100px" alt="logo" src="./assets/imgs/logo.png" />
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol>
              <IonItem hidden={!needRegister}>
                <IonLabel position="floating">Nome*</IonLabel>
                <Controller
                  render={props =>
                    <IonInput placeholder="Digite seu nome" value={props.value} onIonChange={e => props.onChange(e.detail.value)} />
                  }
                  name="nome"
                  defaultValue=""
                  onChangeName="onIonChange"
                  rules={{ validate: () => (!needRegister || !!getValues().nome) }}
                  control={control}
                />
              </IonItem>
              {
                showError('nome')
              }

              <IonItem>
                <IonLabel position="floating">Email*</IonLabel>
                <Controller
                  render={props =>
                    <IonInput placeholder="Digite seu email" value={props.value} onIonChange={e => props.onChange(e.detail.value)} />
                  }
                  name="email"
                  defaultValue=""
                  onChangeName="onIonChange"
                  rules={{
                    required: true,
                    pattern: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/
                  }}
                  control={control}
                />
              </IonItem>
              {
                showError('email')
              }

              <IonItem>
                <IonLabel position="floating">Senha*</IonLabel>
                <Controller
                  render={props =>
                    <IonInput placeholder="Digite sua senha" type="password" value={props.value} onIonChange={e => props.onChange(e.detail.value)} />
                  }
                  name="senha"
                  defaultValue=""
                  onChangeName="onIonChange"
                  rules={{ required: true, min: 8 }}
                  control={control}
                />
              </IonItem>
              {
                showError('senha')
              }

            </IonCol>
          </IonRow>
          <IonRow>
            <IonText className="cursor font-small ion-padding" hidden={!needRegister} onClick={() => setNeedRegister(false)}>Já tem conta?</IonText>
            <IonText className="cursor font-small ion-padding" hidden={needRegister} onClick={() => setNeedRegister(true)}>Ainda não tem conta?</IonText>
          </IonRow>
          <IonRow className="ion-justify-content-center">
            <IonCol size="auto">
              <IonButton fill="outline" onClick={() => loginWithGoogle()}>
                <IonIcon className="ion-margin-end" icon={logoGoogle} />
                <span>Login via Google</span>
              </IonButton>
            </IonCol>

            <IonCol size="auto" hidden={needRegister}>
              <IonButton fill="outline" onClick={handleSubmit(loginWithEmailAndPassword)}>
                <IonIcon className="ion-margin-end" icon={mail} />
                <span>Login via Email e senha</span>
              </IonButton>
            </IonCol>

            <IonCol size="auto" hidden={!needRegister}>
              <IonButton fill="outline" onClick={handleSubmit(
                (validData) => registerByEmail(validData),
                (errors) => showErrors(errors))
              }>
                <IonIcon className="ion-margin-end" icon={mail} />
                <span>Registrar e entrar</span>
              </IonButton>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  )
}

export default Auth;
